import React, { useEffect, useContext } from "react";
import { useParams, useLocation } from "react-router-dom";

import { GlobalContext } from "../../app/providers/GlobalState";

import { getLabel } from "../../shared/utils/labelConfig";

import MenuEnsinoEspecialTurma from "./components/MenuEnsinoEspecialTurma";
import MenuEnsinoEspecial from "./components/MenuEnsinoEspecial";
import MenuTurma from "./components/MenuTurma";
import MenuDisciplina from "./components/MenuDisciplina";

const Menu = ({ context }) => {
    const globalContext = useContext(GlobalContext);

    const { turma, pagina } = useParams();

    const { pathname } = useLocation();
    const raiz = pathname.split("/")[1];

    var inicioUrl = `/${raiz}/${turma.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}`;

    let menuOpcaoAtivo = pagina ?? "";

    const valoresPermitidos = [14, 15, 16, 17, 18, 19, 20, 21, 22, 33];
    const acessos = globalContext.acessos?.filter(x => valoresPermitidos.includes(x.func))?.map(x => x.func);

    const canalId = parseInt(localStorage.getItem("entidade_id"));
    const nivelEnsino = context.nivelEnsino;

    const labelDisciplinas = getLabel("visaoGeral", { canalId, nivelEnsino });

    useEffect(() => {
        if (!context.subcursos && localStorage.getItem("temp_opcao_voltar") != null) {
            localStorage.setItem("opcao_voltar", localStorage.getItem("temp_opcao_voltar"));
            localStorage.removeItem("temp_opcao_voltar");
        }
    }, [turma]);

    if (context.ensinoEspecial && context.subcursos)
        return <MenuEnsinoEspecialTurma inicioUrl={inicioUrl} menuOpcaoAtivo={menuOpcaoAtivo} acessos={acessos} />;
    if (context.ensinoEspecial) return <MenuEnsinoEspecial inicioUrl={inicioUrl} menuOpcaoAtivo={menuOpcaoAtivo} acessos={acessos} />;
    if (context.subcursos)
        return <MenuTurma inicioUrl={inicioUrl} menuOpcaoAtivo={menuOpcaoAtivo} acessos={acessos} labelDisciplinas={labelDisciplinas} />;
    return <MenuDisciplina inicioUrl={inicioUrl} menuOpcaoAtivo={menuOpcaoAtivo} acessos={acessos} labelDisciplinas={labelDisciplinas} />;
};

export default Menu;
